module.exports = __webpack_public_path__ + "img/icon_23years_en.75a88cbe.png";